import React, {
  useCallback,
  useState,
  useRef,
  useMemo,
  useEffect,
} from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';

import { Container, Button } from 'react-bootstrap';

import { OptionTypeBase } from 'react-select';
import { useToast } from '../../../hooks/toast';
import api from '../../../services/api';

import Loading from '../../Loading';
import { ICartaoSaude } from '../../../pages/CartaoSaudeDetalhe';
import getResponseErrors from '../../../utils/getResponseErrors';
import SelectSync, { IOption } from '../../SelectSync';
import { useBeneficio } from '../../../hooks/beneficio';
import { formatPrice } from '../../../utils/funcoes';

interface IReturnSimulacao {
  PlaValor: number;
  parcelas?: {
    CprValor: number;
    CprDataVenc: Date;
    CprHistorico: string;
  }[];
  geraNovoContrato: boolean;
}

type ComponentProps = {
  PlaCodigo: number;
  updated_at: Date;
  CartaoNovo: boolean;
  handleFecharComponent(dados: ICartaoSaude): void;
};

interface ISubmitForm {
  PbnCodigo: string;
}

const CartaoSaudeBeneficio: React.FC<ComponentProps> = ({
  PlaCodigo,
  updated_at,
  CartaoNovo,
  handleFecharComponent,
}) => {
  const { addToast } = useToast();
  const { beneficio, buscaOptionsBeneficio } = useBeneficio();
  const [loading, setLoading] = useState(false);
  const [dadosSimulados, SetDadosSimulados] = useState<
    | {
        valorParcela: string;
        valorPlano: string;
        numeroParcelas: number;
        geraNovoContrato: boolean;
      }
    | undefined
  >(undefined);

  useEffect(() => {
    async function loadBenefícios(): Promise<void> {
      await buscaOptionsBeneficio();
    }
    if (!beneficio || Object.keys(beneficio).length === 0) loadBenefícios();
  }, []);

  const optionsBeneficioFormatado = useMemo(() => {
    if (!beneficio) return undefined;
    return beneficio.map(opt => {
      const opcao: IOption = {
        value: opt.PbnCodigo.toString(),
        label: opt.PbnNome,
        isDisabled: opt.PbnApenasNovo && !CartaoNovo,
      };
      return opcao;
    });
  }, [beneficio, CartaoNovo]);

  const formRefBusca = useRef<FormHandles>(null);

  const handleSubmitForm = useCallback(
    async (dados: ISubmitForm) => {
      setLoading(true);
      try {
        formRefBusca.current?.setErrors({});
        if (!dados.PbnCodigo) {
          formRefBusca.current?.setFieldError(
            'PbnCodigo',
            'Selecione o Benefício',
          );
          addToast({ type: 'error', title: 'Selecione o benefício' });
          return;
        }

        const response = await api.post<ICartaoSaude>('planos/addbeneficio', {
          PlaCodigo,
          PbnCodigo: Number(dados.PbnCodigo),
          updated_at,
        });

        handleFecharComponent(response.data);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível salvar os dependentes',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    },
    [PlaCodigo, updated_at, addToast, handleFecharComponent],
  );

  const handleSimula = useCallback(
    async (selected: OptionTypeBase | null) => {
      if (selected === null) return;
      setLoading(true);
      try {
        const response = await api.post<IReturnSimulacao>(
          'planos/beneficioSimula',
          {
            PlaCodigo,
            PbnCodigo: Number(selected.value),
            updated_at,
          },
        );
        const { parcelas, PlaValor, geraNovoContrato } = response.data;
        SetDadosSimulados({
          numeroParcelas: parcelas?.length || 0,
          valorPlano: formatPrice(PlaValor),
          valorParcela: formatPrice(parcelas ? parcelas[0].CprValor : 0),
          geraNovoContrato,
        });
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível simular adição de dependentes',
          type: 'error',
          description: mensagemErro,
        });
        // SetPacientesAdicionar(state => {
        //   state.pop();
        //   if (state) return state;
        //   return [];
        // });
      } finally {
        setLoading(false);
      }
    },
    [addToast, PlaCodigo, updated_at],
  );

  const handleSubmitBeneficio = useCallback(() => {
    formRefBusca.current?.submitForm();
  }, []);

  return (
    <Container style={{ height: '100%', minHeight: '250px' }}>
      {loading && <Loading />}
      <h6>Escolher um benefício</h6>
      {optionsBeneficioFormatado && (
        <>
          <Form ref={formRefBusca} onSubmit={handleSubmitForm}>
            <SelectSync
              name="PbnCodigo"
              label=""
              size="lg"
              placeholder="Digite para buscar"
              handleSelectChange={handleSimula}
              options={optionsBeneficioFormatado}
            />
          </Form>
          <div className="d-flex justify-content-between align-items-baseline mt-2 py-2">
            {dadosSimulados && (
              <p style={{ fontSize: '.9rem' }}>
                O valor das parcelas do plano sera:{' '}
                <b>{dadosSimulados.valorPlano}</b>.
                {dadosSimulados.numeroParcelas > 0 && (
                  <span>
                    Parcela adicional <b>{dadosSimulados.numeroParcelas}</b> de{' '}
                    <b>{dadosSimulados.valorParcela}</b>
                  </span>
                )}
                {dadosSimulados.geraNovoContrato && (
                  <div className="alert alert-warning px-3 py-1 mt-2">
                    <h5>Atenção!</h5>
                    Essa operação írá gerar um novo contrato, começando da
                    parcela 1 até a 12.
                  </div>
                )}
              </p>
            )}
          </div>
          <Button
            type="button"
            size="sm"
            variant="success"
            onClick={handleSubmitBeneficio}
          >
            Salvar Benefício
          </Button>

          {/* <Button type="submit" size="sm" className="mt-2" variant="success">
         Salvar Benefício
      </Button> */}
        </>
      )}
    </Container>
  );
};

export default CartaoSaudeBeneficio;
